import { Injectable } from '@angular/core';
import { toISOString } from '@services/analytics-services/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CachingApiService } from '@services/core-services/api-cache.service';

@Injectable({ providedIn: 'root' })
export class AggregatedStatDataService {
  constructor(private readonly cacheApi: CachingApiService) {}

  getAggregatedStatdata(context: any): Observable<any[]> {
    return this.cacheApi
      .getWithCache<any>('analytics/charts', {
        ...context,
        date_from: toISOString(context.date_from),
        date_to: toISOString(context.date_to),
      })
      .pipe(map(response => response.content.stats as any[]));
  }
}
